import { useRouteShellContext } from "@components/routeShellContext"
import { companyDetails } from "@lib/data"
import * as m from "@paraglide/messages"

export function CompanyDetailsTable() {
  const { locale } = useRouteShellContext()
  return (
    <div className="relative z-[1] mx-auto mt-[14rem] max-w-[1200px] bg-[var(--deep-blue)] py-[2rem] [--clip-inset:40px] [clip-path:polygon(var(--clip-inset)_0,100%_0,100%_calc(100%-var(--clip-inset)),calc(100%-var(--clip-inset))_100%,0_100%,0_var(--clip-inset))]">
      <table
        data-id="company-details-table"
        className="mx-auto mb-[4rem] max-w-[min(90%,800px)] p-[2rem]"
      >
        <caption className="bg-[var(--deep-blue)] p-[0.5em] font-bold text-[3rem] text-[var(--white)]">
          {m.company_companyDetails_label({}, { locale: locale })}
        </caption>
        <tbody>
          {companyDetails(locale).map((value) => (
            <tr key={value.label}>
              <th className="min-w-[100px] px-[0.5em] py-[0.25em] text-right align-top text-[2rem] text-[var(--white)] max-sm:block max-sm:px-0 max-sm:py-[0.25em] max-sm:text-left">
                {value.label}
              </th>
              <td className="px-[0.5em] py-[0.25em] text-left align-top text-[2rem] text-[var(--white)] max-sm:block max-sm:pb-[0.5em] max-sm:pl-0">
                <ul className="list-none">
                  {locale === "ja" && ["住所", "会社名"].includes(value.label) ? (
                    <li>{value.content.map((contentKey) => contentKey)}</li>
                  ) : (
                    value.content.map((contentKey) => <li key={contentKey}>{contentKey}</li>)
                  )}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default CompanyDetailsTable
